// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-b4Prp","block_wrapper":"block_wrapper-Fqt8X"};